import PropTypes from 'prop-types';

import Input from '../../atoms/input';

const AddUpdateProjectDetailsProps = {
  projectName: PropTypes.string.isRequired,
  projectKey: PropTypes.string.isRequired,
  projectDescription: PropTypes.string.isRequired,
  handleProjectNameChange: PropTypes.func.isRequired,
  handleProjectKeyChange: PropTypes.func.isRequired,
  handleProjectDescriptionChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    projectName: PropTypes.string,
    projectKey: PropTypes.string,
    projectDescription: PropTypes.string,
  }),
};

const AddUpdateProjectDetails = (props) => {
  const { projectName, projectKey, projectDescription, handleProjectNameChange, handleProjectKeyChange, handleProjectDescriptionChange, errors } = props;

  return (
    <div className="border-cards">
      <div className="border-card">
        <span className="border-card-title">Enter details and we&apos;ll create a project for you to help you get started quickly.</span>
        {/* Project name */}
        <div className="border-card-input-container">
          <span className="border-card-label">Project name</span>
          <Input error={!!errors.projectName} helperText={errors.projectName} value={projectName} onChange={handleProjectNameChange} autoFocus placeHolder="Enter Project name" />
        </div>
        {/* Project key */}
        <div className="border-card-input-container">
          <span className="border-card-label">Project key</span>
          <Input error={!!errors.projectKey} helperText={errors.projectKey} value={projectKey} onChange={handleProjectKeyChange} placeholder="Enter Project key" />
        </div>
        {/* Project description */}
        <div className="border-card-input-container">
          <span className="border-card-label">Description</span>
          <Input error={!!errors.projectDescription} helperText={errors.projectDescription} value={projectDescription} onChange={handleProjectDescriptionChange} size="small" multiline rows={4} placeholder="Enter Project description" />
        </div>
      </div>
    </div>
  );
};

AddUpdateProjectDetails.propTypes = AddUpdateProjectDetailsProps;

export default AddUpdateProjectDetails;
